import { render, staticRenderFns } from "./Hotlist.vue?vue&type=template&id=6b7b6923&scoped=true"
import script from "./Hotlist.vue?vue&type=script&lang=js"
export * from "./Hotlist.vue?vue&type=script&lang=js"
import style0 from "./Hotlist.vue?vue&type=style&index=0&id=6b7b6923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b6923",
  null
  
)

export default component.exports